import {Component, input, OnInit} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-block-style-paragraph',
  standalone: true,
  imports: [],
  templateUrl: './block-style-paragraph.component.html',
  styleUrl: './block-style-paragraph.component.css'
})
export class BlockStyleParagraphComponent implements OnInit {
  data = input<any>();

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    console.log('paragraph:', this.data());
  }

  sanitize(cell: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(cell);
  }
}
